<template>

    <m-edit1/>

    <m-dashboard-layout-2 v-bind='{...{"menuPosition":"store_nav","sideBar":"col-lg-3","contentWrapper":"col-lg-9"},...{}}' :style='""' class="my-2" >
                <template #p-2>   <m-h5 v-bind='{...{},...{}}' :style='"font-size: 13px;"' class="my-3 pb-2 border-bottom" >
                <template #default>کاربران حذف شده   </template>
                </m-h5><m-users-trash-1 v-bind='{...{},...{}}' :style='""' class="" ></m-users-trash-1></template>
                </m-dashboard-layout-2>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mDashboardLayout2 from '@moeinmdn/miw-alpha-components/src/package/DashboardLayout/DashboardLayout2'; import mH5 from '@moeinmdn/miw-alpha-components/src/package/Tags/H5'; import mUserTrash1 from '@moeinmdn/miw-alpha-components/src/package/User/Trash/UserTrash1';

export default {
    name: 'HomeView',
    components: {mEdit1, mDashboardLayout2,mH5,mUserTrash1 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
